import { animate, style, transition, trigger } from '@angular/animations'
import { DatePipe, NgFor, NgIf, NgSwitch, NgSwitchCase } from '@angular/common'
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core'
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms'
import { ActivatedRoute, Router, RouterLinkActive } from '@angular/router'
import { NgIcon, provideIcons } from '@ng-icons/core'
import { heroDocumentDuplicate, heroDocumentText, heroFolder, heroMegaphone, heroPencil, heroUsers } from '@ng-icons/heroicons/outline'
import { KENDO_BUTTONS } from '@progress/kendo-angular-buttons'
import { DialogActionsComponent, DialogComponent, DialogService, KENDO_DIALOGS, WindowCloseResult, WindowRef, WindowService } from '@progress/kendo-angular-dialog'
import { DropDownListComponent, KENDO_DROPDOWNS } from '@progress/kendo-angular-dropdowns'
import { ExcelExportData } from '@progress/kendo-angular-excel-export'
import { CellTemplateDirective, ColumnComponent, DataBindingDirective, ExcelCommandDirective, ExcelComponent, GridComponent, GridToolbarFocusableDirective, KENDO_GRID, KENDO_GRID_EXCEL_EXPORT, KENDO_GRID_PDF_EXPORT, PageChangeEvent, PagerSettings, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { KENDO_INDICATORS } from '@progress/kendo-angular-indicators'
import { KENDO_INPUTS } from '@progress/kendo-angular-inputs'
import {
  CompositeFilterDescriptor,
  SortDescriptor,
  State,
  process,
} from '@progress/kendo-data-query'
import { SVGIcon, fileExcelIcon, folderIcon } from '@progress/kendo-svg-icons'
import * as CryptoJS from 'crypto-js'
import { ToastrService } from 'ngx-toastr'
import { Subscription } from 'rxjs'
import { environment } from '../../../environments/environment'
import { AccountListCacheService } from '../../@theme/services/account-list-cache.service'
import { ClientServices } from '../../@theme/services/clients.service'
import { DataService } from '../../@theme/services/data.service'
import { FilterService } from '../../@theme/services/filter.service'
import { InitUserService } from '../../@theme/services/init-user.service'
import { RepServices } from '../../@theme/services/replist.service'
import { MiddlemanService } from '../../auth/services/Middleman.service'
import { Column } from '../../models/column.model'
import { Utilities } from '../../utilities/utilities'
import { ClientinfoComponent } from '../ClientInfo/clientinfo.component'
import { FilemanagerComponent } from '../FileManager/filemanager.component'
import { ViewAccountNotesComponent } from './notes/viewaccountnotes.component'
type NebularStatus = 'primary' | 'success' | 'info' | 'warning' | 'danger' | 'basic' | 'control';
// Rows fetched for the instant first paint before the full list arrives.
const ACCOUNT_PREVIEW_ROWS = 100
@Component({
  selector: 'gd--viewacct',
  templateUrl: './viewaccounts.component.html',
  styleUrls: ['./viewaccounts.component.scss'],
  imports: [
    KENDO_DROPDOWNS,
    KENDO_GRID,
    KENDO_INPUTS,
    KENDO_GRID_PDF_EXPORT,
    KENDO_GRID_EXCEL_EXPORT,
    KENDO_INDICATORS,
    KENDO_DIALOGS, KENDO_BUTTONS,
    GridComponent,
    DataBindingDirective,
    ToolbarTemplateDirective,
    NgIf,
    ExcelCommandDirective,
    GridToolbarFocusableDirective,
    NgFor,
    ColumnComponent,
    NgSwitch,
    NgSwitchCase,
    CellTemplateDirective,
    RouterLinkActive,
    ExcelComponent,
    DialogComponent,
    ViewAccountNotesComponent,
    DialogActionsComponent,
    DropDownListComponent,
    DatePipe,
    NgIcon
  ],
  providers: [
    provideIcons({ heroDocumentDuplicate, heroUsers, heroPencil, heroDocumentText, heroFolder, heroMegaphone })
  ],animations: [
    trigger('simpleFadeAnimation', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('300ms ease-out', style({ opacity: 1 }))
      ]),
      transition(':leave', [
        animate('300ms ease-in', style({ opacity: 0 }))
      ])
    ])
  ]
})
export class ViewAccountsComponent implements OnInit, OnDestroy, AfterViewInit {
  public folderSVG: SVGIcon = folderIcon
  loading = false;
  // Full list still downloading behind the preview rows.
  private _loadingAll = false
  public get loadingAll(): boolean {
    return this._loadingAll
  }
  // The loading banner sits above the grid, so the grid resizes when it toggles.
  public set loadingAll(value: boolean) {
    if (this._loadingAll === value) return
    this._loadingAll = value
    this.scheduleGridHeight()
  }
  @ViewChild('gridContainer', { static: false }) gridContainer?: ElementRef
  public gridContainerHeight = 500 // Space available above the footer
  // Applied grid height: the rows' natural height, capped at gridContainerHeight.
  public gridHeight = 500
  private resizeObserver?: ResizeObserver
  private observedGridTable?: Element
  private fullListLoaded = false
  private fetching = false
  private destroyed = false;
  private overlayEl!: HTMLDivElement;
  public folderExcel: SVGIcon = fileExcelIcon
  buttonState = 'default-button'
  @ViewChild(GridComponent, { static: false })
  public grid: GridComponent
  public viewallblot: string
  public NeedRolePermission = true
  public noShow = false
  public subscription: Subscription = new Subscription()
  public viewer: Array<any> = []
  public viewerduplicate: Array<any> = []
  public type = 'numeric'
  public clientId: string
  public selectval: string
  public readingClientId: number
  public clientName: string
  public clientfaxId: number
  private decPassword: string
  public repId: string
  public aftersubmit: boolean
  public sponsorinsurancelist: Array<any> = []
  public sponsortradingfaxlist: Array<any> = []
  private selectioninsurance: any
  private selectionfax: any

  public readaccountname: string
  public group: any[] = [
    {
      field: 'accountName',
    },
  ]
  public virtual: any = {
    itemHeight: 28,
  }
  public filter: CompositeFilterDescriptor = {
    logic: 'and',
    filters: [],
  }
  public sort: SortDescriptor[] = [
    {
      field: 'modifiedDate',
      dir: 'desc',
    },
  ]
  public pageSettings: PagerSettings = {
    buttonCount: 3,
    info: true,
    type: 'numeric',
    pageSizes: true,
    previousNext: true,
  }
  public formGroup: UntypedFormGroup
  public opened = false
  public windowRef: WindowRef
  public openup = false
  public openworddocselection: boolean
  public openednotes: boolean
  private startdate = new UntypedFormControl(new Date())
  private enddate = new UntypedFormControl(new Date())
  public noteheader: string
  gridExcelexport: any[] = []
  ngModelDate = new Date()
  ngModelendDate = new Date()
  param1: string
  param2: string
  public buttonCount = 10
  public info = true
  public pageSizes = true
  public previousNext = true
  public show = false
  public skip = 0
  public enabled = true
  public pageSize = 12
  public duration = 1200
  private rparam: any
  private acn: number
  selectedItem = '1'
  public aggregates: any[] = []
  public state: State = {
    skip: 0,
    sort: this.sort,
    filter: this.filter,
  }
  private roleString: string

  public columns: Column[]
  data: any[] = [];
  constructor(
    private cdref: ChangeDetectorRef,
    private _requestserv: MiddlemanService,
    private router: Router,
    private route: ActivatedRoute,
    private ur: ClientServices,
    private fx: FilterService,
    private toastr: ToastrService,
    private ngZone: NgZone,
    private theservice: RepServices,
    private initUserService: InitUserService,
    private dialogService: DialogService,
    private windowService: WindowService,
    private dataService: DataService,
    private accountListCache: AccountListCacheService,
  ) {
    this.loading = true;
    this.columns = this.dataService.clientColumns
    const storageValue =
      localStorage.getItem('rrolelisted') == undefined
        ? ''
        : localStorage.getItem('rrolelisted')
    const paramTR = CryptoJS.AES.decrypt(
      storageValue,
      environment.securepw,
    ).toString(CryptoJS.enc.Utf8)

    this.noShow = false
    this.decPassword = environment.decPassword
    if (
      this.route.snapshot.queryParams['existingTaxId'] &&
      this.route.snapshot.queryParams['myLast']
    ) {
      this.subscription.add(
        this.route.queryParams.subscribe((params) => {
          const paramT = CryptoJS.AES.decrypt(
            params['existingTaxId'].trim(),
            this.decPassword.trim(),
          ).toString(CryptoJS.enc.Utf8)
          const paramL = CryptoJS.AES.decrypt(
            params['myLast'].trim(),
            this.decPassword.trim(),
          ).toString(CryptoJS.enc.Utf8)
          this.param1 = paramT
          this.param2 = paramL
        }),
      )
    }
    if (this.route.snapshot.queryParams['AccountN']) {
      this.subscription.add(
        this.route.queryParams.subscribe((params) => {
          const checkParamT = CryptoJS.AES.decrypt(
            params['AccountN'].trim(),
            this.decPassword.trim(),
          ).toString(CryptoJS.enc.Utf8)
          this.acn = Number(decodeURI(checkParamT))
          this.loading = false
          this.noShow = true
        }),
      )
    }

    this.opened = false
    this.viewallblot = ''
    this.aftersubmit = false
    this.noteheader = 'Notes for Account: '
    if (decodeURI(paramTR).toLowerCase() === 'admin') {
      this.NeedRolePermission = true
    }
    this.subscription.add(
      this.initUserService.userPreferences$.subscribe((data) => {
        // check if data is an empty object
        if (data && Object.keys(data).length) {
          // set field to camel case and direction to asc or desc
          this.pageSize = data.clientRows
          this.applySort([
            {
              field: data.clientSortField,
              dir: data.clientSortDir,
            },
          ])
        }
      }),
    )
    // A sibling subscription, not a nested one: nesting re-subscribed to the
    // view state on every preferences emission. The view state holds the sort
    // the user last left in the grid, so it lands after the preference default.
    this.subscription.add(
      this.initUserService.accountViewState$.subscribe((viewState) => {
        if (viewState && Object.keys(viewState).length) {
          this.filter = viewState.filter
          this.applySort(viewState.sort)
        }
      }),
    )
    this.allData = this.allData.bind(this)
  }

  public asPageable = (value) => Utilities.asType<PagerSettings>(value)
  public pageChange(event: PageChangeEvent): void {
    this.skip = event.skip
    this.GetDataLoad()
  }
  loadData() {
    this.updateReasonColumnVisibility();
  }
  updateReasonColumnVisibility(filter?: any) {
    const reasonColumn = this.columns.find(c => c.field === 'reasondescription');
    if (!reasonColumn) return;
    if (!filter || !filter.filters || filter.filters.length === 0) {
      reasonColumn.hidden = true;
      return;
    }
    const accountOpenFilter = filter.filters.find((f: any) => f.field === 'accountOpen');

    if (accountOpenFilter) {
      const expectedValue = accountOpenFilter.value;
      reasonColumn.hidden = !(expectedValue === false);
    } else {
      reasonColumn.hidden = true;
    }
  }
  onAccountOpenChange() {
    this.updateReasonColumnVisibility();
  }
  ngOnInit(): void {
    this.loadData();
    this.subscription.add(
      this._requestserv.notifyObservable$.subscribe(() => {
        // A client was added/edited elsewhere — bypass the cache and reload.
        this.GetDataLoad(true)
        return
      }),
    )
    this.opened = false
    if (this.route.snapshot.queryParams['AccountN']) {
      this.subscription.add(
        this.route.queryParams.subscribe((params) => {
          const checkParamT = CryptoJS.AES.decrypt(
            params['AccountN'].trim(),
            this.decPassword.trim(),
          ).toString(CryptoJS.enc.Utf8)
          this.acn = Number(decodeURI(checkParamT))
        }),
      )
    }
    const storageValueReturn =
      localStorage.getItem('rvarietylist') == undefined
        ? ''
        : localStorage.getItem('rvarietylist')
    const paramT =
      CryptoJS.AES.decrypt(storageValueReturn, environment.securepw);
    const decrypted = paramT.toString(CryptoJS.enc.Utf8);
    const checkParamT = decodeURI(decrypted)
    this.roleString = checkParamT
    this.GetDataLoad()
    return
  }

  ngAfterViewInit(): void {
    this.scheduleGridHeight()
    if (this.gridContainer && typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => this.scheduleGridHeight())
      this.resizeObserver.observe(this.gridContainer.nativeElement)
    }
  }

  ngOnDestroy(): void {
    this.destroyed = true
    this.resizeObserver?.disconnect()
    this.subscription.unsubscribe()
  }

  @HostListener('window:resize')
  onWindowResize(): void {
    this.scheduleGridHeight()
  }

  // Recalculates after the current render so layout changes above the grid
  // (loading banner) are already in place when measured.
  private scheduleGridHeight(): void {
    if (typeof window === 'undefined') return
    setTimeout(() => {
      if (this.destroyed) return
      const previous = this.gridHeight
      this.calculateGridHeight()
      if (this.gridHeight !== previous) {
        this.cdref.detectChanges()
      }
    })
  }

  private calculateGridHeight(): void {
    if (!this.gridContainer) return
    // Fill from the grid's top edge down to the fixed app footer (which
    // overlays the bottom of the window), leaving room for the card borders
    // and layout padding below the grid so the page itself does not scroll.
    const footer = document.querySelector('app-footer > div') as HTMLElement | null
    const footerHeight = footer?.offsetHeight || 64
    const bottomGap = footerHeight + 24
    const top = this.gridContainer.nativeElement.getBoundingClientRect().top
    // Ensure minimum height
    this.gridContainerHeight = Math.max(
      300,
      Math.floor(window.innerHeight - top - bottomGap),
    )
    // A definite height keeps the grid's own scrollbar working: short pages
    // shrink to their rows, long pages scroll inside the grid.
    const natural = this.measureNaturalGridHeight()
    this.gridHeight =
      natural === null
        ? this.gridContainerHeight
        : Math.min(this.gridContainerHeight, natural)
  }

  // Height the grid needs to show every row on the current page without
  // scrolling: everything outside the rows area (toolbar, header, filter row,
  // pager, horizontal scrollbar) plus the rows table itself.
  private measureNaturalGridHeight(): number | null {
    const gridEl = this.gridContainer?.nativeElement.querySelector('.k-grid') as HTMLElement | null
    const content = gridEl?.querySelector('.k-grid-content') as HTMLElement | null
    const table = content?.querySelector('table') as HTMLElement | null
    if (!gridEl || !content || !table) return null
    // Re-measure whenever the rows change (paging, page size, filtering, data).
    if (this.resizeObserver && this.observedGridTable !== table) {
      if (this.observedGridTable) this.resizeObserver.unobserve(this.observedGridTable)
      this.resizeObserver.observe(table)
      this.observedGridTable = table
    }
    const chrome = gridEl.offsetHeight - content.clientHeight
    return Math.ceil(chrome + table.offsetHeight)
  }

  public filterChange(filter: CompositeFilterDescriptor): void {
    this.state.filter = filter
    this.skip = 0
  //  console.log(JSON.stringify(filter))
    this.updateReasonColumnVisibility(filter);
  }

  public sortChange(sort: SortDescriptor[]): void {
    // Set directly rather than via applySort: clearing the sort yields an empty
    // array, which is a legitimate state the guard there deliberately rejects.
    this.sort = sort
    this.state = { ...this.state, sort }
  }

  // The grid binds [sort]="state.sort". `state` captured the initial array at
  // field-init, so reassigning `this.sort` on its own never reached the grid -
  // it kept sorting by the hardcoded default. Route every inbound sort here.
  private applySort(sort: SortDescriptor[]) {
    if (!sort?.length || !sort[0]?.field) {
      return
    }
    this.sort = sort
    this.state = { ...this.state, sort }
  }

  public dataStateChange(state: State): void {
    const viewState = {
      filter: state.filter,
      sort: state.sort,
    }
    this.initUserService.setAccountViewState(viewState)
  }
  // Cache key, scoped by role. Backed by AccountListCacheService (Cache Storage
  // + in-memory mirror) so the large client list survives navigation and full
  // reloads without re-downloading. Wiped on logout / login (holds PII).
  private get cacheKey(): string {
    return this.roleString === 'REP' ? 'rep' : 'admin'
  }

  // Pass forceRefresh = true to bypass the cache and re-fetch (e.g. after a
  // client is added/edited elsewhere).
  GetDataLoad(forceRefresh = false) {
    const key = this.cacheKey

    // Instant path: if the list is already mirrored in memory this session,
    // paint it synchronously with no async gap.
    const inMem = forceRefresh ? null : this.accountListCache.getSync(key)
    if (inMem) {
      this.markFullListLoaded()
      this.applyData(inMem)
      return
    }

    // pageChange() also calls this method, so a load already in flight must not
    // be duplicated - let the running one finish.
    if (this.fetching && !forceRefresh) {
      return
    }

    this.fetching = true
    this.loading = true

    // Otherwise look in Cache Storage (survives reload); fall back to a live
    // fetch on a miss or forced refresh.
    const lookup = forceRefresh
      ? Promise.resolve(null)
      : this.accountListCache.get(key)

    lookup.then((cached) => {
      if (this.destroyed) return
      if (cached) {
        this.markFullListLoaded()
        this.applyData(cached)
      } else {
        this.fetchFromServer(key)
      }
    })
  }

  // Two requests go out together on a cold load: a capped one that paints the
  // grid almost immediately, and the full list that replaces it and fills the
  // cache. They are not chained, so the full list is never held up by the
  // preview. Until it lands, `loadingAll` warns that a search is incomplete.
  private fetchFromServer(key: string) {
    this.fullListLoaded = false
    this.loadingAll = true

    this.subscription.add(
      this.listRequest(ACCOUNT_PREVIEW_ROWS).subscribe({
        next: (response) => {
          // Discard if the full list already won the race - it is a superset.
          if (this.fullListLoaded || this.destroyed) return
          this.applyData(response ?? [])
        },
        // A failed preview is not worth surfacing; the full load owns the error.
        error: () => undefined,
      }),
    )

    this.subscription.add(
      this.listRequest().subscribe({
        next: (response) => {
          const data = response ?? []
          this.markFullListLoaded()
          // Fire-and-forget cache write; failure just means no persistence.
          void this.accountListCache.set(key, data)
          this.applyData(data)
        },
        error: () => {
          this.markFullListLoaded()
          this.loading = false
          this.cdref.detectChanges()
        },
      }),
    )
  }

  private listRequest(take?: number) {
    return this.roleString === 'REP'
      ? this.ur.getaccountlistbyRepId(take)
      : this.theservice.getNportSubmissionTypeList(take)
  }

  private markFullListLoaded() {
    this.fullListLoaded = true
    this.loadingAll = false
    this.fetching = false
  }

  public get hasActiveFilter(): boolean {
    return (this.state.filter?.filters?.length ?? 0) > 0
  }

  public get previewRowCount(): number {
    return ACCOUNT_PREVIEW_ROWS
  }

  private applyData(data: any[]) {
    // A cache read can resolve after the user has navigated away; don't touch
    // a destroyed view.
    if (this.destroyed) return
    this.handleResponse(data)
    if (this.roleString !== 'REP') {
      this.filterClientData()
    }
    // Cache reads resolve asynchronously — nudge change detection so the grid
    // updates even when the paint happens outside Angular's normal flow.
    this.cdref.detectChanges()
  }
  private mapRow = (item: any) => ({
    ...item,
    dateEntered: new Date(item.dateEntered),
    // Strip the time so the date filter matches by calendar day (the cell only
    // shows MM/dd/yyyy); use null (not '') so date comparisons don't break.
    modifiedDate: item.modifiedDate
      ? new Date(new Date(item.modifiedDate).setHours(0, 0, 0, 0))
      : null,
    approvedDate: item.approvedDate ? new Date(item.approvedDate) : '',
  })

  private handleResponse(response: any[]) {
    this.viewerduplicate = response.map(this.mapRow)
    this.viewer = [...this.viewerduplicate]
    this.loading = false
  }

  private filterClientData() {
    if (this.acn !== undefined) {
      this.viewer = this.viewerduplicate.filter((b) => b.clientId === this.acn)
    }
    if (this.param1 && this.param2) {
      this.viewer = this.viewer.filter(
        (b) => b.lastName === this.param2 && b.last4Digits === this.param1,
      )
    }
  }
  viewClientInfo(clientId: number) {
    const clientInfoDialogRef = this.dialogService.open({
      title: 'View Client',
      content: ClientinfoComponent,
      maxHeight: '95%',
      width: '850px',
      maxWidth: '95%',
      actions: [{ text: 'Close', themeColor: 'primary' }],
    })

    const clientInfo = clientInfoDialogRef.content.instance
    clientInfo.clientId = clientId
  }

  showall() {
    this.GetDataLoad()
    this.acn = undefined
    this.noShow = false
    this.viewer = this.viewerduplicate
  }
  public editHandler({ sender, rowIndex }) {
    sender.editRow(rowIndex, this.formGroup)
  }

  returndata(component) {
    const options = component.workbookOptions()
    const rows = options.sheets[0].rows
    let altIdx = 0
    rows.forEach((row) => {
      if (row.type == 'data') {
        if (altIdx % 2 !== 0) {
          row.cells.forEach((cell) => {
            cell.background = '#aabbcc'
          })
        }
        altIdx++
      }
    })
    setTimeout(() => this.downloadtimeout(), 7000)
    component.save(options)
  }
  downloadtimeout() {
    this.showToast('success', 'Please wait, your file will auto download.')

  }
  showToast(status: NebularStatus, message: string) {
    // Map Nebular statuses to ngx-toastr methods
    switch (status) {
      case 'success':
        this.toastr.success(message, 'Success');
        break;
      case 'info':
      case 'primary':
        this.toastr.info(message, 'Info');
        break;
      case 'warning':
        this.toastr.warning(message, 'Warning');
        break;
      case 'danger':
        this.toastr.error(message, 'Error');
        break;
      default:
        this.toastr.show(message);
        break;
    }
  }
  onMouseEnter() {
    this.buttonState = 'hover-button'
  }

  onMouseLeave() {
    this.buttonState = 'default-button'
  }
  /* click open FileManager popup */
  viewFiles(
    repid: string,
    clientInfo: string,
    LastName: string,
    FirstName: string,
  ): void {
    // If windowRef is not null, close the window before opening a new one
    if (this.windowRef) {
      this.windowRef.close()
    }

    this.clientId = clientInfo
    this.repId = repid
    if (LastName.length > 0) {
      this.clientName = LastName + ', ' + FirstName
    } else {
      this.clientName = FirstName
    }
    this.overlayEl = document.createElement('div');
    this.overlayEl.classList.add('k-overlay');
    document.body.appendChild(this.overlayEl);
    this.windowRef = this.windowService.open({
      title: 'File Manager',
      content: FilemanagerComponent,
      width: 1000,
      height: 675,
    })

    this.windowRef.result.subscribe(() => this.destroyOverlay());
    const fileManager = this.windowRef.content.instance

    fileManager.outputClientId = this.clientId
    fileManager.viewallblot = this.viewallblot
    fileManager.outputrepId = this.repId
    fileManager.clientName = this.clientName
    fileManager.viewaccountsscreen = true

    // Sets windowRef to null when window is closed
    this.windowRef.result.subscribe((result) => {
      if (result instanceof WindowCloseResult) {
        this.windowRef = null
      }
    })
  }
  private destroyOverlay(): void {
    if (this.overlayEl && document.body.contains(this.overlayEl)) {
      document.body.removeChild(this.overlayEl);
    }
  }
  close(): void {
    this.opened = false
  }
  onDialogOpen(c: number): void {
    this.readingClientId = c
    this.openup = true
  }
  onDialogClose(): void {
    this.openup = false
    this.openworddocselection = false
  }
  onDialogClosenotes(): void {
    this.openednotes = false
  }
  onDialogOpenWord(cl: number) {
    this.Getservicesponsor(cl)
    this.Getservicesponsortrading(cl)
    this.readingClientId = cl
    this.openworddocselection = true
    this.aftersubmit = false
  }
  onDialogOpenNotes(cl: number, ac: string) {
    this.readingClientId = cl
    this.openednotes = true
    this.readaccountname = ac
  }
  LoadviewfrmAddaccounts(v: any) {
    return
  }

  viewTransactions(clientId: number, repId: number) {
    const encryptingclient = clientId.toString()
    const encryptingrep = repId.toString()
    const clientParam = CryptoJS.AES.encrypt(
      encodeURI(encryptingclient).trim(),
      environment.securepw.trim(),
    ).toString()
    const repParam = CryptoJS.AES.encrypt(
      encodeURI(encryptingrep).trim(),
      environment.securepw.trim(),
    ).toString()
    this.router.navigate(['/pages/Transactions/app-transviewer'], {
      queryParams: { R: clientParam, Rp: repParam },
    })
  }
  viewTransactionsList(repId: number, clientId: number) {
    const encryptingclient = clientId.toString()
    const clientParam = CryptoJS.AES.encrypt(
      encodeURI(encryptingclient).trim(),
      environment.securepw.trim(),
    ).toString()
    this.router.navigate(['/pages/TransactionList/view'], {
      queryParams: { cld: clientParam },
    })
  }
  EditAccount(clientId: number) {
    this.router.navigate(['/pages/AccountForm/edit-account'], {
      queryParams: { Cld: clientId },
    })
  }
  Getservicesponsor(c: number): void {
    this.selectval = 'INSURANCE'
    this.clientfaxId = c
    this.subscription.add(
      this.fx.Getservicesponsorinsurancelist().subscribe((r: any) => {
        this.sponsorinsurancelist = r
      }),
    )
  }
  Getservicesponsortrading(c: number): void {
    this.selectval = 'TRADING'
    this.clientfaxId = c
    this.subscription.add(
      this.fx.Getservicesponsortradingfaxlist().subscribe((response) => {
        this.sponsortradingfaxlist = response
      }),
    )
  }
  selectioninsuranceevent(s: any) {
    this.selectionfax = s.sponsorId
  }
  selectionfaxevent(s: any) {
    this.selectionfax = s.sponsorId
  }
  Submit() {
    this.aftersubmit = true
    const param = {
      blotterId: 0,
      clientId: this.clientfaxId,
      sponsorId: this.selectionfax,
      FaxType: this.selectval,
    }
    this.subscription.add(
      this.fx.GetCODFaxReturndata(param).subscribe((response) => {
        const url = window.URL.createObjectURL(response)
        const link = document.createElement('a')
        link.href = url
        link.download = 'CODFaxCoversheet' + '.doc'
        link.click()
        URL.revokeObjectURL(url)
      }),
    )
  }
  filteredData(component) {
    setTimeout(() => this.returndata(component), 3000)
  }
  public startinit() {
    this.downloadtimeout();
  }
  public allData(): ExcelExportData {
    const result: ExcelExportData = {
      data: process(this.viewer, {
        sort: this.sort,
        filter: this.filter,
      }).data,
    };
    return result;
  }
}
